import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import FontIcon from "material-ui/FontIcon";
import NotFound from "../../components/notFound";

const Conekta = window.Conekta;

var libros = [
  {
    img: require("../../img/libro1.png"),
    title: "La Empresa Hoy: Los Nuevos Retos Financieros y Fiscales",
    author: "Moisés Torres Herrera",
    descripcion: (
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;La empresa debe enfrentar hoy nuevos retos
        financieros y fiscales. Al igual que el empresario, la empresa se
        constituye bajo una mentalidad de riesgo permanente. Socialmente debe
        cumplir con un objetivo primordial: generar riqueza, y en consecuencia,
        generar fuentes de trabajo.<br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;El emprendedor, constituido en empresario, sabe
        que fracasar no es opción, su empeño se caracteriza por transformar cada
        situación poco exitosa en una verdadera experiencias de aprendizaje. El
        empresario con vocación conoce el aglomerado camino hacia el éxito y
        eventualmente, también ha conocido el solitario sendero del fracaso.<br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;Mucho se puede decir sobre las empresas y los
        empresarios, pero solo quien ha constituido concretamente una empresa
        conoce el vertiginoso camino de su generación, desarrollo y expansión.
        Son múltiples las problemáticas oscilatorias que van desde el esfuerzo
        sostenido por lograr y mantener una adecuada salud financiera, hasta el
        logro de cierta estabilidad en su relación para con el fisco. En este
        libro se comparten seis diferentes abordajes sobre tales problemáticas
        financieras y fiscales.
      </p>
    ),
    precio: 250,
    envio: 50
  },
  {
    img: require("../../img/libro2.png"),
    title:
      "Movilidad Social e Inclusión Educativa y Laboral de los Egresados de Bachillerato a Distancia",
    author:
      "Alma Elena Gutiérrez leyton, Reyna Verónica Serna Alejandro, Rosario Lucero Cavazos Salazar",
    descripcion: (
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Estudiar a distancia representa un cambio de
        paradigma para quien se aventura en esta modalidad, ya que generalmente
        se trata de estudiantes que han sido formados en la presencialidad y que
        deberán desarrollar las competencias necesarias para lograr el éxito
        académico.<br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;En este libro se presentan las experiencias de
        un grupo de estudiantes que logró concluir exitosamente sus estudios;
        ellos comparten las estrategias que cada uno implementó durante el
        bachillerato a distancia. Los hallazgos obtenidos ofrecen información
        relevante para estimular y alentar dichas estrategias de manera
        sistematizada, a fin de lograr que más estudiantes concluyan sus
        estudios de bachillerato en el modelo a distancia.
      </p>
    ),
    precio: 250,
    envio: 50
  }
];

export default class Compra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      numero: "",
      cvc: "",
      mes: "",
      ano: "",
      phone: "",
      email: "",
      calle: "",
      ciudad: "",
      estado: "",
      cp: "",
      quantity: 1,
      visible: true,
      conektaUser: null
    };
    this.routeParam = this.props.match.params;
    this.libro = null;
    this.form = null;
  }
  componentWillMount() {
    this.libro = libros[this.routeParam.id - 1];
  }
  conektaSuccessResponseHandler(token) {
    var self = this;
    // console.log(token);
    // console.log({
    //   uname: this.state.nombre,
    //   uemail: this.state.email,
    //   uphone: this.state.phone,
    //   utoken: token
    // });
    fetch("https://shielded-scrubland-72467.herokuapp.com/pago/user", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        uname: this.state.nombre,
        uemail: this.state.email,
        uphone: this.state.phone,
        utoken: token
      })
    })
      .then(response => response.json())
      .then(responseJSON => {
        console.log(responseJSON);
        console.log(this.state.cp, typeof this.state.cp);
        fetch("https://shielded-scrubland-72467.herokuapp.com/pago", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ucostumeID: responseJSON.id,
            uname: this.state.nombre,
            uphone: this.state.phone,
            ustreet: this.state.calle,
            ucity: this.state.ciudad,
            ustate: this.state.estado,
            ucp: this.state.cp,
            utarjeta: responseJSON.default_payment_source_id,
            libro: {
              name: self.libro.title,
              unit_price: self.libro.precio,
              quantity: self.state.quantity
            }
          })
        })
          .then(response => response.json())
          .then(responseJSON => {
            console.log(responseJSON);
          });
      })
      .catch(e => {
        console.log(e);
      });
  }
  conektaErrorResponseHandler(response) {
    console.log(response);
  }
  show_overlay(e) {
    e.preventDefault();

    Conekta.setPublishableKey("key_NtXW2q5kEmEaxHP8MXDdYzQ");
    Conekta.token.create(
      this.form,
      this.conektaSuccessResponseHandler.bind(this),
      this.conektaErrorResponseHandler.bind(this)
    );
  }
  onChange(event, opt) {
    switch (opt) {
      case "nombre":
        this.setState({ nombre: event.target.value });
        break;
      case "numero":
        this.setState({ numero: event.target.value });
        break;
      case "cvc":
        this.setState({ cvc: event.target.value });
        break;
      case "mes":
        this.setState({ mes: event.target.value });
        break;
      case "ano":
        this.setState({ ano: event.target.value });
        break;
      case "email":
        this.setState({ email: event.target.value });
        break;
      case "phone":
        this.setState({ phone: event.target.value });
        break;
      case "calle":
        this.setState({ calle: event.target.value });
        break;
      case "ciudad":
        this.setState({ ciudad: event.target.value });
        break;
      case "estado":
        this.setState({ estado: event.target.value });
        break;
      case "CP":
        this.setState({ cp: event.target.value });
        break;
      default:
        break;
    }
  }
  renderForm() {
    return (
      <div>
        <RaisedButton
          label="Comprar"
          onClick={() => this.setState({ visible: false })}
          primary={true}
          fullWidth={true}
          style={{
            margin: 12,
            display: this.state.visible ? null : "none"
          }}
          labelPosition="before"
          icon={<FontIcon className="material-icons">shopping_cart</FontIcon>}
        />
        <Row style={{ visibility: this.state.visible ? "hidden" : null }}>
          <Col xs={12} md={3} lg={3}>
            <FlatButton
              label="-"
              onClick={() => {
                if (this.state.quantity >= 2) {
                  this.setState({ quantity: this.state.quantity - 1 });
                }
              }}
            />
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p
              style={{
                marginTop: 5,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0,
                textAlign: "center"
              }}
            >
              {this.state.quantity}
            </p>
          </Col>
          <Col xs={12} md={3} lg={3}>
            <FlatButton
              label="+"
              onClick={() => {
                this.setState({ quantity: this.state.quantity + 1 });
              }}
            />
          </Col>
        </Row>
        <form
          ref="sendForm"
          style={{ visibility: this.state.visible ? "hidden" : null }}
        >
          <div>
            <label>
              <span>Email</span>
            </label>
            <input
              type="email"
              size="20"
              onChange={e => this.onChange(e, "email")}
            />
          </div>
          <div>
            <label>
              <span>Telefono (10 digitos)</span>
            </label>
            <input
              type="number"
              size="10"
              onChange={e => this.onChange(e, "phone")}
            />
          </div>
          <div>
            <label>
              <span>Nombre dueno de tarjeta</span>
            </label>
            <input
              type="text"
              size="20"
              data-conekta="card[name]"
              onChange={e => this.onChange(e, "nombre")}
            />
          </div>
          <div>
            <label>
              <span>Numero de tarjeta</span>
            </label>
            <input
              type="text"
              size="20"
              data-conekta="card[number]"
              onChange={e => this.onChange(e, "numero")}
            />
          </div>
          <div>
            <label>
              <span>CVC</span>
            </label>
            <input
              type="number"
              size="4"
              data-conekta="card[cvc]"
              onChange={e => this.onChange(e, "cvc")}
            />
          </div>
          <div>
            <label>
              <span>Dia de vencimineto (MM/YYYY)</span>
            </label>
            <input
              type="number"
              size="2"
              data-conekta="card[exp_month]"
              onChange={e => this.onChange(e, "mes")}
            />
            <span>/</span>
            <input
              type="number"
              size="4"
              data-conekta="card[exp_year]"
              onChange={e => this.onChange(e, "ano")}
            />
          </div>
          <label>Informacion de envio</label>
          <div>
            <label>
              <span>Calle</span>
            </label>
            <input type="text" onChange={e => this.onChange(e, "calle")} />
          </div>
          <div>
            <label>
              <span>Ciudad</span>
            </label>
            <input type="text" onChange={e => this.onChange(e, "ciudad")} />
          </div>
          <div>
            <label>
              <span>Estado</span>
            </label>
            <input type="text" onChange={e => this.onChange(e, "estado")} />
          </div>
          <div>
            <label>
              <span>Codigo Postal</span>
            </label>
            <input type="text" onChange={e => this.onChange(e, "CP")} />
          </div>
          <button type="submit" onClick={this.show_overlay.bind(this)}>
            Pagar
          </button>
        </form>
      </div>
    );
  }
  render() {
    if (!this.libro) return <NotFound />;
    return (
      <div className="navMargin container">
        <h2>{this.libro.title}</h2>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <img
              src={this.libro.img}
              alt={this.title}
              style={{ width: 320, height: 450 }}
            />
          </Col>
          <Col xs={12} md={6} lg={6}>
            {this.libro.descripcion}
            <p>
              $ {Number(this.libro.precio).toFixed(2)} +{" "}
              {Number(this.libro.envio).toFixed(2)} de envio
            </p>
            {this.renderForm()}
          </Col>
        </Row>
      </div>
    );
  }
  componentDidMount() {
    this.form = this.refs.sendForm;
  }
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/compra/index.js